"use strict";

import angular from "angular";
import template from "./progress-comparision.view.ng.html";
import "./progress-comparision.scss";

const name = "nuProgressComparision";
const factory = [
    function () {
        return {
            bindToController: true,
            replace: true,
            controllerAs: "vm",
            restrict: "E",
            scope: {
                progress: "=",
                labelValue: "=",
                labelName: "=",
                variationValue: "=",
                percent: "=",
                tooltipValue: "="
            },
            template,
            controller: function () {}
        };
    }
];
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
